import React from 'react';
import { ProductCard } from './ProductCard';
import { Button } from './Button';
export function FeaturedProducts() {
  const products = [{
    title: 'Gen3-PSS-Gloves USAT',
    price: '$69.00',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png'
  }, {
    title: 'Gen3 E-Foot Gear',
    price: '$110.84',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg'
  }, {
    title: 'Gen3 Transmitter TK-Strike (Head)',
    price: '$556.85',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/32CSZRc127TCj3au4ThHui/GEN3_TRANSMITTER_TK-STRIKE_(HEAD).webp'
  }, {
    title: 'Gen3 Transmitter TK-Strike (Body)',
    price: '$459.35',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/1ih3djYezzVq8985HX8oSL/GEN3_TRANSMITTER_TK-STRIKE_(BODY).webp'
  }, {
    title: 'TK-Strike Gen3 Receiver',
    price: '$688.34',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/55DtFd96dsvi8vp6TjTcGE/TK-STRIKE_GEN3_RECEIVER.webp'
  }, {
    title: 'Gen3 Electronic Body Protector',
    price: '$847.22',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/nf6K7oc2o7k9Lq2qdDp2cD/Red-GEN3_ELECTRONIC_BODY_PROTECTOR.webp'
  }, {
    title: 'Gen3 E-Head Gear',
    price: '$399.99',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/pZymF2e8PGGmiMTnD1QNCR/Red-and-BlueGEN3_E-HEAD_GEAR.webp'
  }, {
    title: 'Gen 3 Software Download',
    price: '$99.99',
    category: 'Gen 3',
    image: 'https://cdn.magicpatterns.com/uploads/uzhJjiwifSbakuQBq1HFz4/Gen3_Software_download.png'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-75">
          <div data-id="element-76">
            <h2 className="text-3xl font-black text-gray-900 uppercase tracking-tight" data-id="element-77">
              Featured Equipment
            </h2>
            <div className="w-24 h-1 bg-red-600 mt-4" data-id="element-78"></div>
            <p className="mt-4 text-gray-600 font-medium max-w-2xl" data-id="element-79">
              Top-rated Daedo gear trusted by athletes worldwide.
            </p>
          </div>
          <a href="#shop-all" className="mt-6 md:mt-0 hidden md:inline-flex" data-id="element-80">
            <Button variant="secondary" data-id="element-81">Shop All Products</Button>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-82">
          {products.map((product, index) => <ProductCard key={index} title={product.title} price={product.price} category={product.category} image={product.image} isNew={true} data-id="element-83" />)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-84">
          <a href="#shop-all" data-id="element-85">
            <Button variant="secondary" className="w-full" data-id="element-86">
              Shop All Products
            </Button>
          </a>
        </div>
      </div>
    </section>;
}